import React, { useState, useRef } from "react";
import { Link } from "react-router-dom";

export default function Marketplace() {
  const [formData, setFormData] = useState({
    fullName: "",
    companyName: "",
    email: "",
    phone: "",
    industry: "",
    applications: [],
    devices: [],
    message: "",
  });

  const formRef = useRef(null);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (type === "checkbox") {
      setFormData((prev) => ({
        ...prev,
        [name]: checked
          ? [...prev[name], value]
          : prev[name].filter((item) => item !== value),
      }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form Data Submitted:", formData);
  };

  const scrollToForm = () => {
    formRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="min-h-screen bg-gray-100 text-gray-900">
      {/* Page Header */}
      <header className="text-center py-20 bg-blue-200 text-white">
        <h1 className="text-6xl font-bold text-gray-800">
          FlexNet Marketplace
          <br />
          <span className="pt-5">
            Your Gateway to Smart Connectivity Solutions
          </span>
        </h1>
        <p className="mt-2 text-lg">
          Discover, connect, and manage a wide range of FlexNet applications
          tailored to your industry needs.
        </p>
      </header>

      {/* Hero Section */}
      <section className="text-center py-16 bg-white">
        <div className="max-w-4xl mx-auto ">
          <img
            src="https://highways.today/wp-content/uploads/2024/07/Contech_3.jpg"
            alt="FlexNet Marketplace"
            className="mx-auto mb-6 rounded-lg shadow-lg"
          />
          <div>
            <p className="text-xl">
              FlexNet Marketplace helps businesses explore, select, and manage
              advanced 4G/5G applications seamlessly. From smart energy
              management to industrial automation, find the right solutions to
              power your operations.
            </p>
            <div className="mt-6">
              <button
                onClick={scrollToForm}
                className="bg-blue-600 text-white px-6 py-3 rounded-lg"
              >
                Request Access
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* How It Works Section */}
      <section className="py-16 bg-blue-200">
        <div className="max-w-5xl mx-auto text-center">
          <h2 className="text-3xl font-bold">
            How Does FlexNet Marketplace Work?
          </h2>
          <div className="mt-6 text-left  marketplace-how">
            <div className="bg-white p-4 shadow rounded-lg">
              <p>
                <strong>Start with FlexNet Connectivity:</strong> Gain access by
                first establishing secure, high-speed 4G/5G connectivity.
              </p>
            </div>
            <div className="bg-white p-4 shadow rounded-lg">
              <p>
                <strong>Explore Solutions:</strong> Browse curated industrial
                applications for energy, logistics, construction, and more.
              </p>
            </div>
            <div className="bg-white p-4 shadow rounded-lg">
              <p>
                <strong>Subscribe to Industrial Applications:</strong>{" "}
                Pre-integrated applications ensure seamless performance.
              </p>
            </div>
            <div className="bg-white p-4 shadow rounded-lg">
              <p>
                <strong>Order Devices:</strong> Purchase pre-configured devices
                such as cameras, scanners, and drones.
              </p>
            </div>
            <div className="bg-white p-4 shadow rounded-lg">
              <p>
                <strong>Manage & Scale:</strong> Use the FlexNet dashboard for
                monitoring and scaling.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Case Studies Testimonias Section */}
      <div className="surface-section px-4 py-8 md:px-6 lg:px-8 text-center">
        <div className="mb-3 font-bold text-3xl">
          <span className="text-blue-600"> Key Features</span>
        </div>
        <div className="grid justify-center">
          <div className="text-900 text-xl mb-3 font-medium"></div>
          <div className="technical-specifications">
            <div className="text-700 line-height-3 technical-specifications-box text-xl">
              <ul className="list-disc pl-5 mt-3">
                <li className="before:content-['\2022'] before:mr-2 before:text-blue-600">
                  Centralized access to FlexNet applications and devices
                </li>
                <li className="before:content-['\2022'] before:mr-2 before:text-blue-600">
                  Seamless integration with FlexNet Connectivity
                </li>
                <li className="before:content-['\2022'] before:mr-2 before:text-blue-600">
                  Secure and scalable infrastructure
                </li>
                <li className="before:content-['\2022'] before:mr-2 before:text-blue-600">
                  Dedicated support for deployment and maintenance
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <section>
        {/* How It Works Section */}
        <section className="py-16 bg-blue-200">
          <div className="max-w-5xl mx-auto text-center">
            <h2 className="text-3xl font-bold">
              Benefits of Using FlexNet Marketplace
            </h2>
            <div className="mt-6 text-left  marketplace-how">
              <div className="bg-white p-4 shadow rounded-lg">
                <p>
                  <strong>Comprehensive Solutions:</strong> From IoT devices to
                  AI-powered analytics, find everything you need in one place.
                </p>
              </div>
              <div className="bg-white p-4 shadow rounded-lg">
                <p>
                  <strong>Seamless Integration:</strong> Designed to work with
                  FlexNet Connectivity, reducing the need for complex setups.
                </p>
              </div>
              <div className="bg-white p-4 shadow rounded-lg">
                <p>
                  <strong>Real-Time Monitoring:</strong>
                  Keep track of your network performance, device health, and
                  application status in real-time.
                </p>
              </div>
              <div className="bg-white p-4 shadow rounded-lg">
                <p>
                  <strong>Secure and Reliable:</strong> Built with
                  enterprise-grade security protocols to ensure data protection
                  and system reliability.
                </p>
              </div>
            </div>
          </div>
        </section>
      </section>

      {/* Request Access Form */}
      <section ref={formRef} className="py-16 bg-white">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl font-bold">
            Request Access to FlexNet Marketplace
          </h2>
          <form className="mt-6 space-y-4 text-left" onSubmit={handleSubmit}>
            <input
              className="w-full p-2 border rounded"
              name="fullName"
              placeholder="Full Name"
              onChange={handleChange}
            />
            <input
              className="w-full p-2 border rounded"
              name="companyName"
              placeholder="Company Name"
              onChange={handleChange}
            />
            <input
              className="w-full p-2 border rounded"
              name="email"
              type="email"
              placeholder="Email Address"
              onChange={handleChange}
            />
            <input
              className="w-full p-2 border rounded"
              name="phone"
              type="tel"
              placeholder="Phone Number"
              onChange={handleChange}
            />
            <select
              className="w-full p-2 border rounded"
              name="industry"
              onChange={handleChange}
            >
              <option>Industry</option>
              <option>Manufacturing</option>
              <option>Mining</option>
              <option>Maritime</option>
              <option>Agriculture</option>
              <option>Energy</option>
              <option>Logistics</option>
              <option>Construction</option>
              <option>Smart Cities</option>
              <option>Oil & Gas</option>
              <option>Public Safety</option>
              <option>Crisis Management</option>
              <option> Healthcare</option>
              <option>Utilities</option>
              <option>Ports</option>
              <option>Elevators</option>
              <option>Parking</option>
              <option>Retail</option>
              <option>Transportation</option>
              <option>Education</option>
              <option>Other</option>
            </select>
            <div>
              <label className="block font-bold mb-3">
                Applications of Interest:
              </label>
              <div className="grid grid-cols-2 gap-2">
                {[
                  "Smart Grid Monitoring",
                  "Asset Tracking",
                  "Predictive Maintenance",
                  "Real-Time Video Analytics",
                  "Industrial Automation",
                  "Fleet Management",
                  "Smart Surveillance",
                  "Environmental Monitoring",
                  "Remote Equipment Control",
                  "Energy Management",
                  "Safety and Compliance Monitoring",
                  "Digital Twin Applications",
                  "Push-to-Talk (PTT) Communication",
                  "AI-Powered Analytics",
                  "Workflow Optimization",
                  "Autonomous Vehicle Support",
                  "Supply Chain Visibility",
                  "Condition-Based Monitoring",
                  "Emergency Response Solutions",
                  "Network Performance Monitoring",
                  "Smart Building Management",
                  "Smart Agriculture Solutions",
                  "Maritime Operations Management",
                  "Crisis Communication Systems",
                  "Airport Operations Optimization",
                  "Smart Port Logistics",
                  "Public Safety Monitoring",
                  "Connected Healthcare Solutions",
                  "Retail Analytics & Management",
                ].map((app) => (
                  <label key={app}>
                    <input
                      type="checkbox"
                      name="applications"
                      value={app}
                      onChange={handleChange}
                    />{" "}
                    {app}
                  </label>
                ))}
              </div>
            </div>

            <div>
              <label className="block font-bold mb-3">
                Devices of Interest:
              </label>
              <div className="grid grid-cols-2 gap-2">
                {[
                  "Cameras (Surveillance, Thermal, AI-Enabled)",
                  "Scanners (Barcode, RFID, Industrial)",
                  "Drones (Inspection, Surveillance, Delivery)",
                  "IoT Sensors (Temperature, Humidity, Motion)",
                  "Edge Computing Devices",
                  "Wearables (Smart Helmets, Smart Glasses)",
                  "Routers & Gateways",
                  "Smart Displays",
                  "GPS Trackers",
                  "Communication Devices (Radios, PTT Devices)",
                  "Industrial Robots",
                  "Access Control Devices",
                  "Smart Meters",
                  "Autonomous Guided Vehicles (AGVs)",
                  "Body-Worn Cameras",
                  "Smart Locks",
                  "Connected Medical Devices",
                  "Smart Parking Sensors",
                ].map((device) => (
                  <label key={device}>
                    <input
                      type="checkbox"
                      name="devices"
                      value={device}
                      onChange={handleChange}
                    />{" "}
                    {device}
                  </label>
                ))}
              </div>
            </div>

            <textarea
              className="w-full p-2 border rounded"
              name="message"
              placeholder="Message/Additional Information"
              onChange={handleChange}
            />
            <button
              className="w-full bg-blue-600 text-white px-6 py-3 rounded-lg"
              type="submit"
            >
              Request Access
            </button>
          </form>
        </div>
      </section>

      {/* Call-to-Action Section */}
      <section className="py-16 bg-blue-200 text-white text-center">
        <h2 className="text-3xl font-bold">
          Ready to Transform Your Business with FlexNet?
        </h2>
        <div className="mt-6 space-x-4">
          <Link to="/vertical-solutions">
            <button className="bg-white text-blue-600 px-6 py-3 rounded-lg">
              Explore Solutions
            </button>
          </Link>
          <Link to="/contact-us">
            <button className="bg-white text-blue-600 px-6 py-3 rounded-lg">
              Contact Us
            </button>
          </Link>
        </div>
      </section>
    </div>
  );
}
